export { default } from './nav-skeleton';
